
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { ClientFormData } from "@/hooks/useClientForm";

interface ClientInfoFormProps {
  formData: ClientFormData;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (name: string, value: string) => void;
}

export const ClientInfoForm: React.FC<ClientInfoFormProps> = ({ 
  formData, 
  handleChange, 
  handleSelectChange 
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <span className="text-white/70 block">Name</span>
        <Input
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="bg-white/20 border-white/30 text-white"
        />
      </div>
      <div className="space-y-1">
        <span className="text-white/70 block">Email</span>
        <Input
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="bg-white/20 border-white/30 text-white"
        />
      </div>
      <div className="space-y-1">
        <span className="text-white/70 block">Phone</span>
        <Input
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          className="bg-white/20 border-white/30 text-white"
        />
      </div>
      <div className="space-y-1">
        <span className="text-white/70 block">Age</span>
        <Input
          name="age"
          type="number"
          value={formData.age}
          onChange={handleChange}
          className="bg-white/20 border-white/30 text-white"
        />
      </div>
      <div className="space-y-1">
        <span className="text-white/70 block">Gender</span>
        <Select
          value={formData.gender}
          onValueChange={(value) => handleSelectChange("gender", value)}
        >
          <SelectTrigger className="bg-white/20 border-white/30 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="male">Male</SelectItem>
            <SelectItem value="female">Female</SelectItem>
            <SelectItem value="other">Not Specified</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <span className="text-white/70 block">Goals</span>
        <Textarea
          name="goals"
          value={formData.goals}
          onChange={handleChange}
          className="bg-white/20 border-white/30 text-white min-h-[100px]"
        />
      </div>
      <div className="space-y-1">
        <span className="text-white/70 block">Notes</span>
        <Textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          className="bg-white/20 border-white/30 text-white min-h-[100px]"
        />
      </div>
    </div>
  );
};
